import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import Reveal from "./Reveal";

export default function Differentials() {
  const { t } = useLang();

  return (
    <section
      id="differentials"
      data-testid="differentials-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="sap-container">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <Reveal className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="sap-divider-gold" />
              <span className="sap-overline">{t.differentials.overline}</span>
            </div>
            <h2
              className="font-serif leading-[1.1] tracking-tight"
              style={{
                fontSize: "clamp(1.9rem, 3.6vw, 3.2rem)",
                color: "var(--sap-navy)",
                fontWeight: 400,
              }}
            >
              {t.differentials.title}
            </h2>
          </Reveal>
        </div>

        <ol className="divide-y border-y" style={{ borderColor: "#e7e7e7" }}>
          {t.differentials.items.map((item, i) => (
            <Reveal key={i} delay={i * 40}>
              <li
                data-testid={`differential-${i}`}
                className="group grid grid-cols-12 gap-6 py-8 md:py-10 items-start transition-colors hover:bg-neutral-50"
              >
                <div className="col-span-2 md:col-span-1">
                  <span
                    className="font-serif text-3xl md:text-4xl"
                    style={{ color: "var(--sap-gold)" }}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="col-span-10 md:col-span-5">
                  <h3
                    className="font-serif text-xl md:text-2xl leading-snug"
                    style={{ color: "var(--sap-navy)", fontWeight: 500 }}
                  >
                    {item.title}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-6">
                  <p className="text-[15px] leading-relaxed text-neutral-600">
                    {item.desc}
                  </p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
